/**
 * Handle phone fields using `intl-tel-input` component.
 */

(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define([], factory(root));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.NumberSpinnerHandler = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var $ = jQuery;
	var _hasJQuery = ( $ != null );

	var _hasInitialized = false;
	var _publicMethods = {};
	var _settings = {
		bodyClass: 'has-number-spinner--activated',

		numberSpinnerOptions: {},

		fragmentsUpdateEvent: 'wc_fragment_refresh',
		fragmentsReplacedEvent: 'wc_fragments_refreshed',
	};




	/**
	 * METHODS
	 */



	/*!
	* Merge two or more objects together.
	* (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
	* @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	* @param   {Object}   objects  The objects to merge together
	* @returns {Object}            Merged values of defaults and options
	*/
	var extend = function () {
		// Variables
		var extended = {};
		var deep = false;
		var i = 0;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					// If property is an object, merge properties
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						extended[prop] = extend(extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
	};



	/**
	 * Initialize a phone field.
	 */
	_publicMethods.initAllInputFields = function() {
		// Bail if container selector option is not set
		if ( ! _settings.numberSpinnerOptions || ! _settings.numberSpinnerOptions.containerSelector || '' == _settings.numberSpinnerOptions.containerSelector ) { return; }

		// Get container element
		var containerElements = document.querySelectorAll( _settings.numberSpinnerOptions.containerSelector );

		for ( var i = 0; i < containerElements.length; i++ ) {
			var containerElement = containerElements[i];

			// Initialize number input fields
			NumberSpinner.initInputFields( containerElement, _settings.numberSpinnerOptions );
		}
	}



	/**
	 * Initialize intl phone number inputs
	 */
	_publicMethods.init = function( options ) {
		if ( _hasInitialized ) return;

		// Bail if NumberSpinner script was not loaded
		if ( ! window.NumberSpinner ) { return; }

		// Merge settings
		_settings = extend( _settings, options );

		// Set jQuery event listeners
		if ( _hasJQuery ) {
			$( document.body ).on( _settings.fragmentsReplacedEvent, _publicMethods.initAllInputFields );
		}

		// Initialize number spinner on page load
		NumberSpinner.init();
		_publicMethods.initAllInputFields();

		// Add init class
		document.body.classList.add( _settings.bodyClass );

		_hasInitialized = true;
	};



	//
	// Public APIs
	//
	return _publicMethods;

});
